<script>
    import { onMount } from 'svelte';
    import OfferIzziMovilConfiguration from './OfferIzziMovilConfiguration.svelte';
    import OfferCategoryButton from './OfferCategoryButton.svelte';
    import OfferIzziCombo from './OfferIzziCombo.svelte';

    export let onSelectionChange = () => {};

    export let onChangeMovilMobileData;
    export let selectedMovilMobileData;

    export let onChangeMovilTerm;
    export let selectedMovilTerm;

    export let onChangeCheckedCombos;
    export let checkedCombos;

    export let disableCombo = false;
    export let isNegocios = false;

    const INTERNET = 'internet';
    const TV = 'tv';
    const MOVIL = 'movil';

    let selectedServices = [INTERNET, TV, MOVIL];
    let description = {
        heading: '',
        text: '',
        extraText: '',
    };

    $: hasInternet = selectedServices.includes(INTERNET);
    $: hasTv = selectedServices.includes(TV);
    $: hasMovil = selectedServices.includes(MOVIL);

    $: shouldShowMobileConfiguration = hasInternet && hasMovil;
    $: shouldShowIncludesPhone = hasInternet;
    $: shouldShowCombo =
        shouldShowComboCheck(selectedServices) && !disableCombo;

    onMount(() => {
        description = getServiceDescriptionFromSelection();
    });

    function shouldShowComboCheck(services) {
        return (
            (services.length === 1 && hasInternet) ||
            (services.length === 2 && hasInternet && hasTv)
        );
    }

    function handleServiceSelection(service) {
        if (selectedServices.includes(service)) {
            selectedServices = selectedServices.filter((s) => s !== service);
        } else {
            selectedServices = [...selectedServices, service];
        }
        description = getServiceDescriptionFromSelection();
        onSelectionChange({ detail: selectedServices });
    }

    function getServiceDescriptionFromSelection() {
        const descriptions = {
            'internet,movil,tv': {
                heading: 'Todo en uno, ¡sin complicaciones!',
                text: 'Disfruta de TV, Internet desde 60 Megas, red móvil y llamadas ilimitadas en un solo plan. Podrás relajarte y disfrutar de tu entretenimiento.',
                extraText: '',
            },
            'internet,movil': {
                heading: 'Tu plan, tus reglas.',
                text: 'Telefonía, internet con una súper velocidad y red móvil.',
                extraText: '',
            },
            'internet,tv': {
                heading: 'Tu plan, tus reglas.',
                text: 'Telefonía, internet con una súper velocidad e increíbles canales de televisión.',
                extraText: '',
            },
            internet: {
                heading: '',
                text: 'La telefonía que necesitas con conexión a internet súper rápida.',
                extraText: '',
            },
            tv: {
                heading: '',
                text: 'Relájate con increíbles canales de TV',
                extraText: '¡La decisión es tuya!',
            },
            movil: {
                heading: '',
                text: 'Mantente conectado con tu móvil.',
                extraText: '¡La decisión es tuya!',
            },
        };
        const key = selectedServices.sort().join(',');
        if (isNegocios && (key === 'movil' || key === 'tv')) {
            return { heading: '', text: '', extraText: '' };
        }
        return descriptions[key] || { heading: '', text: '', extraText: '' };
    }
</script>

<div class="offer-content-title">Selecciona los servicios que te interesan</div>
<div class="service-selection">
    <OfferCategoryButton
        label="internet"
        icon="/assets/img/icons/symbol-defs.svg#icon-wifi"
        isActive={hasInternet}
        onClick={() => handleServiceSelection(INTERNET)}
        aria-label="Seleccionar Internet"
    />
    <OfferCategoryButton
        label="tv"
        icon="/assets/img/icons/symbol-defs.svg#icon-tv"
        isActive={hasTv}
        onClick={() => handleServiceSelection(TV)}
        aria-label="Seleccionar TV"
    />
    <OfferCategoryButton
        label="movil"
        icon="/assets/img/icons/symbol-defs.svg#icon-smartphone"
        isActive={hasMovil}
        onClick={() => handleServiceSelection(MOVIL)}
        aria-label="Seleccionar Móvil"
    />
</div>
{#if shouldShowIncludesPhone}
    <div class="phone-included">
        <img
            src="/assets/img/icons/telefonia-included.svg"
            alt="Telefonía incluida"
        />
        <span class="">Telefonía incluida</span>
    </div>
{/if}
<p>
    <span class="fw-bold">{description.heading}</span>
    {description.text}
    <span class="fw-bold">{description.extraText}</span>
</p>
{#if shouldShowMobileConfiguration}
    <OfferIzziMovilConfiguration
        {onChangeMovilMobileData}
        {selectedMovilMobileData}
        {onChangeMovilTerm}
        {selectedMovilTerm}
    />
{/if}
{#if shouldShowCombo}
    <OfferIzziCombo {checkedCombos} {onChangeCheckedCombos} />
{/if}
